export default {
    name: "ClearStoreMixin",
    methods: {
        clearStore() {
            this.$store.commit('setup/clearChoice');
            this.$store.commit('setup/setAddress', {
                address: null
            });
            this.$store.commit('setup/setSuppliers', []);
            this.$store.commit('setup/setEstimate', null);
            this.$store.commit('auth/recommendationCode', null);
        }
    },
}
